/* eslint-disable no-undef */

const schoolBookMapping = () => {
  const openPopupButton = document.getElementById(
    'open-schoolbook-selection-popup'
  );
  const schoolbookPopup = document.getElementById('schoolbook-mapping-popup');
  const selectionPopup = document.getElementById('schoolbook-selection-popup');

  if (!openPopupButton || !schoolbookPopup || !selectionPopup) return;

  openPopupButton.addEventListener('click', event => {
    event.preventDefault();

    const subject = schoolbookPopup.dataset.subject;

    const profileProperties = {
      profile_type: window.Sofatutor.profile?.currentProfileType(),
      profile_level: window.Sofatutor.profileLevel,
      profile_id: window.Sofatutor.profile?.currentProfileId(),
      subject: subject
    };

    Sofatutor.tracking.amplitude.track(
      'schoolbook_add_first_time_pop_up_click',
      profileProperties
    );

    $(schoolbookPopup).foundation('close');
    $(selectionPopup).foundation('open');

    Sofatutor.tracking.amplitude.track(
      'schoolbook_add_pop_up_view',
      profileProperties
    );
  });
};

$(document).on('turbolinks:before-visit', () => {
  Turbolinks.clearCache();
});

preventCachedExecution(() => {
  if (document.querySelector('.schoolbook-selection-popup')) {
    schoolBookMapping();
  }
});
